import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import moment from 'moment';
import { SHORTDATE_FORMAT } from '@/helpers/constants/app';
import SalesBySalesChannel from '@/plugins/graphql/queries/v2/ecommerce/sales-by-sales-channel.gql';
import SalesOverviewItem from '@/components/v2/SalesOverviewItem.vue';
import BaseAnalyticsBanner from '@/components/v2/BaseAnalyticsBanner.vue';
let SalesAnalyticsWrapper = class SalesAnalyticsWrapper extends Mixins(RouterParamsAppMixin, ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.defaultAnalytics = { amount: 0, value: 0, isSalesChannel: true, loading: false };
        this.overallSales = {
            ...this.defaultAnalytics,
            isSalesChannel: false,
            headerTitle: 'Total Monthly Sales',
        };
        this.salesChannels = {
            messenger: {
                ...this.defaultAnalytics,
                headerTitle: 'FB Messenger',
                isPro: false,
                proSettingRoute: '',
                salesChannelIcon: require('../../../assets/images/messenger-overview.svg'),
            },
        };
        this.selectedFilter = moment();
    }
    get isMdpi() {
        // only for approximation
        return this.$vuetify.breakpoint.width < 1080;
    }
    get filterOptions() {
        return [
            { text: 'Today', value: moment() },
            { text: 'Last Week', value: moment().subtract(7, 'days') },
            { text: 'Last Month', value: moment().subtract(1, 'month') },
            { text: 'Last 3 Months', value: moment().subtract(3, 'months') },
            { text: 'Last 6 Months', value: moment().subtract(6, 'months') },
        ];
    }
    get startOfMonth() {
        return moment().startOf('month').format(SHORTDATE_FORMAT);
    }
    get formattedSelectedFilter() {
        return this.selectedFilter.format(SHORTDATE_FORMAT);
    }
    populateOverallSales(overallSales) {
        if (overallSales.length) {
            const overallSale = overallSales[0];
            this.overallSales = {
                ...this.overallSales,
                value: overallSale.count,
                amount: overallSale.sum,
            };
        }
    }
    populateSalesChannels(salesChannels, subscribedPlan) {
        this.salesChannelResetter(subscribedPlan);
        salesChannels.forEach((channel) => {
            const { platformOrigin } = channel;
            Object.assign(this.salesChannels[platformOrigin], {
                ...this.salesChannels[platformOrigin],
                amount: channel.sum,
                value: channel.count,
            });
        });
    }
    salesChannelResetter(subscribedPlan) {
        const keys = Object.keys(this.salesChannels);
        const activated = /pro/.test(subscribedPlan);
        keys.forEach((key) => {
            Object.assign(this.salesChannels[key], {
                ...this.salesChannels[key],
                ...this.defaultAnalytics,
                activated,
            });
        });
    }
    mounted() {
        this.selectedFilter = this.filterOptions[0].value;
    }
};
SalesAnalyticsWrapper = __decorate([
    Component({
        components: {
            SalesOverviewItem,
            BaseAnalyticsBanner,
        },
        apollo: {
            salesAnalytics: {
                query: SalesBySalesChannel,
                variables() {
                    return {
                        startDate: this.formattedSelectedFilter,
                        startOfMonth: this.startOfMonth,
                        appUuid: this.appUUID,
                    };
                },
                watchLoading(loading) {
                    this.defaultAnalytics.loading = loading;
                    this.overallSales.loading = loading;
                    this.salesChannelResetter();
                },
                update(data) {
                    const { overallSales, salesChannels, subscribedPlan } = data;
                    this.populateOverallSales(overallSales);
                    this.populateSalesChannels(salesChannels, subscribedPlan.plan);
                },
            },
        },
    })
], SalesAnalyticsWrapper);
export default SalesAnalyticsWrapper;
